import TimerFormatter from './TimerFormatter';

type OnUpdateCallback = (formattedSecondsRemaining: string, secondsRemaining: number) => void;
type OnCompleteCallback = () => void;

interface TimerOptions {
  duration: number;
  onUpdate?: OnUpdateCallback;
  onComplete?: OnCompleteCallback;
}

class Timer {
  duration: number;

  onUpdate: OnUpdateCallback | undefined;

  onComplete: OnCompleteCallback | undefined;

  interval: number | undefined;

  startTime: number | undefined;

  constructor(options: TimerOptions = { duration: 0 }) {
    this.onUpdate = options.onUpdate;
    this.onComplete = options.onComplete;
    this.duration = options.duration;
  }

  start() {
    this.startTime = new Date().getTime();

    this.interval = window.setInterval(this.onTick, 100);

    this.onTick();
  }

  restart(duration: number) {
    this.duration = duration;

    this.clearInterval();

    this.start();
  }

  private onTick = () => {
    const remaining = this.duration - (new Date().getTime() - this.startTime!);

    if (remaining <= 0) {
      this.clearInterval();

      if (this.onComplete) {
        this.onComplete();
      }
    } else {
      const secondsRemaining = Math.floor(remaining / 1000);

      if (this.onUpdate) {
        this.onUpdate(TimerFormatter.format(secondsRemaining), secondsRemaining);
      }
    }
  };

  private clearInterval = () => {
    if (this.interval) {
      window.clearInterval(this.interval);

      this.interval = undefined;
    }
  };
}

export default Timer;
